import React from 'react';
import { H4 } from "../../styles/typography/typography.js";
import { colors } from "../../styles/variables.js"
import {
  AdditionalWrapStyled,
  AdditionalContainerStyled,
  AdditionalTextStyled,
  AdditionalLogo,
  AdditionalDownloadStyled,
  AdditionalDownloadWrap,
  VideoWrapStyled,
  VideoPreviewStlyed,
  VideoTextStlyed,
} from './style.js';
import i18n from "i18next";


const TabsAdditional = ({ extraImg, extraVideos, extraMaterials }) => {

  // одинаковая верстка для трёх групп видео
  const renderVideos = (list, groupIndex) => list && list.map((item, i) =>
    <VideoWrapStyled key={`${groupIndex}-${i}`}>
      <VideoPreviewStlyed src={item.preview_ru} width="300" height="168" />
      <VideoTextStlyed>
        {item.title} | {item.duration_text}
      </VideoTextStlyed>
      <AdditionalDownloadStyled href={item.download_url} />
    </VideoWrapStyled>
  );

  return (
    <React.Fragment>

      {/*кадры*/}
      {extraImg.length > 0 && <><H4 color="black_text">{i18n.t(`catalog.project.${0}.personnel`)}</H4>
        <AdditionalWrapStyled>
          <AdditionalContainerStyled>
            {extraImg && extraImg.map((cadre, index) =>
              <AdditionalDownloadWrap key={index}>
                <img src={cadre.media} width="160" height="90" alt="" />
                <AdditionalDownloadStyled href={cadre.download_url} />
              </AdditionalDownloadWrap>
            )}
          </AdditionalContainerStyled>
        </AdditionalWrapStyled>
      </>}

      {/*видео*/}
      {extraVideos.length > 0 && <><H4 color="black_text">{i18n.t(`catalog.project.${0}.video`)}</H4>
        <AdditionalWrapStyled>
          <AdditionalContainerStyled>
            {renderVideos(extraVideos[0], 0)}
            {renderVideos(extraVideos[1], 1)}
            {renderVideos(extraVideos[2], 2)}
          </AdditionalContainerStyled>
        </AdditionalWrapStyled>
      </>}

      {/*файлы*/}
      {extraMaterials.length > 0 && <><H4 color="black_text">{i18n.t(`catalog.project.${0}.materials`)}</H4>
        {extraMaterials.map((materials, index) =>
          <AdditionalTextStyled href={materials.download_url} key={index}>
            <AdditionalLogo width="24" height="24" viewBox="0 0 24 24">
              <use xlinkHref="../images/sprite.svg#download" fill={colors.blue_active}></use>
            </AdditionalLogo>
            {materials.name}
          </AdditionalTextStyled>
        )
        }
      </>}

    </React.Fragment>
  );
};

export default TabsAdditional;
